import { Text } from "@chakra-ui/react";
import React from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { RanaSelect } from "@nens/ranalib";
import { Organisation } from "@nens/threedi/openapi-client";

import { AppDispatch } from "../App";
import styles from "../StartScreen/SelectScenario.module.css";
import {
  getSelectedOrganisation,
  setSelectedOrganisation,
} from "../state/selectedStartScreenOptions";

interface MyProps {
  organisations: Organisation[];
  fetchingSelectedOrganisation: boolean;
}

const SelectOrganisation: React.FC<MyProps> = ({
  organisations,
  fetchingSelectedOrganisation,
}: MyProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const selectedOrganisation = useSelector(getSelectedOrganisation);

  const intl = useIntl();

  const selectOrganisationText = intl.formatMessage({
    id: "select_model.billing_goes_to",
    defaultMessage: "Select organisation",
  });

  return (
    <div className={styles.SelectOrganisationContainer}>
      <Text color="brand.analytic" mb={2} fontWeight="bold">
        {selectOrganisationText}
      </Text>
      <RanaSelect
        w="full"
        bg="white"
        value={fetchingSelectedOrganisation ? "" : selectedOrganisation || ""}
        onChange={(organisationId) => dispatch(setSelectedOrganisation(organisationId))}
        options={organisations.map((organisation) => ({
          label: organisation.name,
          value: organisation.uniqueId,
        }))}
        emptyLabel={`-- ${selectOrganisationText} --`}
        isReadOnly={fetchingSelectedOrganisation}
      />
    </div>
  );
};

export default SelectOrganisation;
